// Theme & palette — Phòng Khám Đa Khoa KCN Quế Võ (Blue/White)
export const font = "'Lexend', sans-serif";
export const mono = "'JetBrains Mono', monospace";

export const P = {
  bg: '#f0f4f8',
  card: '#ffffff',
  border: '#d4e0ed',
  borderLight: '#b8cce0',
  primary: '#0072BC',       // PK Đa Khoa KCN Quế Võ main blue
  primaryDark: '#005a96',
  primaryLight: '#e8f4fd',
  accent: '#00A651',        // Green accent (nutrition)
  success: '#16a34a',
  warning: '#e67e22',
  danger: '#dc3545',
  orange: '#f39c12',
  purple: '#8e44ad',
  text: '#141f2a',          // gần đen — chữ chính tương phản tối đa trên nền sáng
  textDim: '#31465b',       // nhãn phụ đậm, đọc rõ
  textMuted: '#48607a',     // chữ mờ nhất vẫn đạt chuẩn tương phản AA

  white: '#ffffff',
  inputBg: '#f8fafc',
  headerBg: '#0072BC',      // Blue header like the website
  headerText: '#ffffff',
};
